module.exports = __webpack_public_path__ + "img/icon-neutral.1efc917.svg";